import { render, staticRenderFns } from "./BrushesDD.vue?vue&type=template&id=512b1aaa&scoped=true"
import script from "./BrushesDD.vue?vue&type=script&lang=js"
export * from "./BrushesDD.vue?vue&type=script&lang=js"
import style0 from "./BrushesDD.vue?vue&type=style&index=0&id=512b1aaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512b1aaa",
  null
  
)

export default component.exports